"use client";

import { useIsEligibleForMobileLoggedOutNavWithCartSignUp } from "@faire/deprecated-retailer-visitor-shared/components/Header/__internal__/useIsEligibleForMobileLoggedOutNavWithCartSignUp";
import { topNavEvent } from "@faire/deprecated-retailer-visitor-shared/components/Header/Events";
import { useSearchPlaceholderWithLoggedOutSearchSuggestionXP } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/SearchPlaceholderStore";
import { TopSearch } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/TopSearch";
import { home } from "@faire/deprecated-retailer-visitor-shared/paths/index";
import { getRetailer } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getRetailer";
import { useSearchPageProductSearchString } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { getCurrentPath } from "@faire/web/common/Path";
import { matchPathWithLocale } from "@faire/web/common/routing/react-utils";
import { isRobot } from "@faire/web/common/user-agent/isRobot";
import React, { useCallback, useEffect } from "react";

interface IProps {
  inputId: string;
  inputDataTestId: string;
  onFocus?: (element: HTMLDivElement | null, isOnToggle?: boolean) => void;
  onBlur?: () => void;
}

export const HeaderSearch: React.FC<IProps> = ({
  onFocus,
  inputId,
  inputDataTestId,
  onBlur,
}) => {
  const retailerToken = getRetailer()?.token;

  const isEligibleForMobileLoggedOutNavWithCartSignUp =
    useIsEligibleForMobileLoggedOutNavWithCartSignUp();
  const isOnHome = matchPathWithLocale(getCurrentPath().pathname, home());
  const shouldAutofocus =
    (isRobot() && isOnHome) || isEligibleForMobileLoggedOutNavWithCartSignUp;

  const searchPageProductSearchString = useSearchPageProductSearchString();

  const {
    placeholder,
    startPlaceholderCycling,
    stopPlaceholderCycling,
    shouldShowLoggedOutSearchSuggestion,
  } = useSearchPlaceholderWithLoggedOutSearchSuggestionXP(
    searchPageProductSearchString
  );

  useEffect(() => {
    return () => {
      stopPlaceholderCycling();
    };
  }, [stopPlaceholderCycling]);

  // This function reference must be stable for page scrolling
  const headerSearchFocus = useCallback(
    (element: HTMLDivElement | null, isOnToggle?: boolean) => {
      topNavEvent("search", retailerToken ?? "");
      onFocus?.(element, isOnToggle);
      startPlaceholderCycling();
    },
    [onFocus, retailerToken, startPlaceholderCycling]
  );

  const blur = useCallback(() => {
    stopPlaceholderCycling();
    onBlur?.();
  }, [onBlur, stopPlaceholderCycling]);

  return (
    <div style={{ flex: "1" }}>
      <TopSearch
        inputId={inputId}
        inputDataTestId={inputDataTestId}
        autofocus={shouldAutofocus}
        onFocus={headerSearchFocus}
        onBlur={blur}
        placeholder={placeholder}
        shouldShowLoggedOutSearchSuggestion={
          shouldShowLoggedOutSearchSuggestion
        }
        searchPageProductSearchString={searchPageProductSearchString}
      />
    </div>
  );
};
